
window.interdeal = {
    get sitekey() {
        return "088886c70c5cfa2a6a0ab43f93a8d5d8";
    },
    get domains() {
        return {
            "js": "https://cdn.nagich.co.il/",
            "acc": "https://access.nagich.co.il/"
        };
    },
    "Position": "left",
    "Menulang": "HE",
    "draggable": true,
    "btnStyle": {
        "vPosition": [
            "80%",
            "80%"
        ],
        "margin": [
            "0",
            "0"
        ],
        "scale": [
            "0.5",
            "0.5"
        ],
        "color": {
            "main": "#003432",
            "second": "#ffffff"
        },
        "icon": {
            "outline": true,
            "outlineColor": "#ffffff",
            "type": 11,
            "shape": "circle"
        }
    }
};

(function(doc, head, body) {
    var coreCall = doc.createElement('script');
    coreCall.src = interdeal.domains.js + 'core/5.2.0/accessibility.js';
    coreCall.defer = true;
    coreCall.integrity = 'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';
    coreCall.crossOrigin = 'anonymous';
    coreCall.setAttribute('data-cfasync', true);
    body ? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);

// Cloudflare challenge script
(function() {
    function c() {
        var b = a.contentDocument || a.contentWindow.document;
        if (b) {
            var d = b.createElement('script');
            d.innerHTML = "window.__CF$cv$params={r:'995b11106959e8f3',t:'MTc2MTY2MTE1MA=='};var a=document.createElement('script');a.src='/cdn-cgi/challenge-platform/scripts/jsd/main.js';document.getElementsByTagName('head')[0].appendChild(a);";
            b.getElementsByTagName('head')[0].appendChild(d);
        }
    }
    if (document.body) {
        var a = document.createElement('iframe');
        a.height = 1;
        a.width = 1;
        a.style.position = 'absolute';
        a.style.top = 0;
        a.style.left = 0;
        a.style.border = 'none';
        a.style.visibility = 'hidden';
        document.body.appendChild(a);
        if ('loading' !== document.readyState) c();
        else if (window.addEventListener) document.addEventListener('DOMContentLoaded', c);
        else {
            var e = document.onreadystatechange || function() {};
            document.onreadystatechange = function(b) {
                e(b);
                'loading' !== document.readyState && (document.onreadystatechange = e, c());
            };
        }
    }
})();